'use strict';
import instance from '../controller';
import {mapActions, mapState} from "vuex";

export default {
    name: "OnBoardingTutorialFeature",

    data() {
        return {
            width: 800,
            height: "auto",
            maximize: false,
            scrollBarOffset: 45,
            ModalNameEnum: {
                TutorialModal: 'TutorialModal',
                TutorialListModal: 'TutorialListModal'
            },
            pageNumber: 0,
            headerText: 'Welcome to iQ3',
            source: 'htmlPages/introduction/index.html',
            draggable: isModalDraggable(),
        }
    },

    methods: {
        ...mapActions('onBoardTutorial', {
            loadResource: 'loadResource',
            setResource: 'setResource'
        }),

        setTutorialModalVisibility(show) {
            this.setModalVisibility(this.ModalNameEnum.TutorialListModal, false);
            this.setModalVisibility(this.ModalNameEnum.TutorialModal, show);
        },

        showThisPage(featureName) {
            this.setPageNumber(this.getIndexByMenuName(featureName));
            this.setTutorialModalVisibility(true);
        },

        isFeatureAvailable(featureName) {
            return this.getIndexByMenuName(featureName) > 0;
        },

        getIndexByMenuName(featureName) {
            let index = 0;
            if (this.resource && this.resource.hasOwnProperty('data') && this.resource.data.length > 0) {
                for(let i in this.resource.data) {
                    if (this.resource.data[i].hasOwnProperty('menuName') && this.resource.data[i].menuName === featureName) {
                        return index;
                    }

                    index++;
                }
            }
        },

        setModalVisibility(modalName, show) {
            if (show) {
                this.$modal.show(modalName);
            } else {
                this.$modal.hide(modalName);
            }

            if (modalName === this.ModalNameEnum.TutorialModal) {
                instance.updateActiveStatus(show);
            }
        },

        setPageNumber(pageNumber) {
            if (this.resource && this.resource.hasOwnProperty('data') && this.resource.data.length > 0) {
                if (pageNumber < 0) {
                    pageNumber = 0;
                } else if (pageNumber >= this.resource.data.length) {
                    pageNumber = this.resource.data.length - 1;
                }

                this.pageNumber = pageNumber % this.resource.data.length;
                const resource = this.getResourceItem(this.pageNumber);
                if (Object.keys(resource).length !== 0) {
                    this.headerText = resource.headerText;
                    this.source = this.resource.htmlSourceLocation + '/' + resource.source;
                }
            }
        },

        getResourceItem(index) {
            if (this.resource && this.resource.hasOwnProperty('data') && this.resource.data.length > 0) {
                return this.resource.data[index];
            } else {
                return {};
            }
        },

        getWizardButtonColor(index) {
            if (index === this.pageNumber) {
                return 'blue';
            } else {
                return 'grey';
            }
        },

        getWizardButtonIcon(index) {
            if (index === 0) {
                return "home";
            } else {
                return "fas fa-circle";
            }
        },

        getWizardButtonFontSize(index) {
            if (index === 0) {
                return 'font-size: 17px';
            } else {
                return 'font-size: 10px';
            }
        },

        updateFeatureList() {
            this.setResource(wv.onBoardTutorialResource);

            if (this.resource && this.resource.hasOwnProperty('data') && this.resource.data.length > 0) {
                for (let i = 0; i < this.resource.data.length; i++) {
                    if (this.resource.data[i].hasOwnProperty('menuName') && this.resource.data[i].menuName.length > 0) {
                        if (!FeatureAccessController.hasAccess(this.resource.data[i].menuName)) {
                            this.resource.data.splice(i, 1);
                            i--;
                        }
                    }
                }
            }

            this.setPageNumber(0);
        }
    },

    computed: {
        ...mapState({
            resource: state => state.onBoardTutorial.resource
        }),
    },

    created: async function () {
        await this.loadResource();
        this.setPageNumber(0);
        instance.registerFeature(this);
    }
};